import React, { useCallback, useEffect, useState, lazy, memo, Component } from 'react';
// Countdown Timer Component
const CountdownTimer = () => {
  const [timeRemaining, setTimeRemaining] = useState(() => {
    // Try to get stored end time from localStorage
    const storedEndTime = localStorage.getItem('offerEndTime');
    if (storedEndTime) {
      // Calculate remaining time based on stored end time
      const endTime = parseInt(storedEndTime, 10);
      const now = Date.now();
      const diff = Math.max(0, endTime - now);
      return diff;
    } else {
      // Set initial countdown time: 17 hours, 34 minutes, 51 seconds in milliseconds
      const initialTime = (17 * 60 * 60 + 34 * 60 + 51) * 1000;
      const endTime = Date.now() + initialTime;
      localStorage.setItem('offerEndTime', endTime.toString());
      return initialTime;
    }
  });
  // Format the time as HH:MM:SS
  const formatTime = milliseconds => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };
  // Update the timer every second
  useEffect(() => {
    if (timeRemaining <= 0) return;
    const intervalId = setInterval(() => {
      setTimeRemaining(prev => {
        const newTime = Math.max(0, prev - 1000);
        return newTime;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeRemaining]);
  return <div className="flex justify-center items-center space-x-1" data-id="element-253">
      <div className="bg-black text-white px-2 py-1 rounded-md" data-id="element-254">
        <span className="font-mono font-bold text-lg" data-id="element-255">
          {formatTime(timeRemaining)}
        </span>
      </div>
    </div>;
};
export const SpecialOffer = () => {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    // Get stored value from localStorage or use default on initial render
    return parseInt(localStorage.getItem('copiesLeft') || '374');
  });
  // Memoize the update function to prevent unnecessary re-renders
  const decreaseCopies = useCallback(() => {
    setCopiesLeft(prevCount => {
      // Random decrease between 1-3
      const decrease = Math.floor(Math.random() * 3) + 1;
      const newCount = Math.max(prevCount - decrease, 5); // Don't go below 5
      // Store in localStorage
      localStorage.setItem('copiesLeft', newCount.toString());
      return newCount;
    });
  }, []);
  useEffect(() => {
    // Set interval with memoized function
    const interval = setInterval(decreaseCopies, 3000);
    return () => clearInterval(interval);
  }, [decreaseCopies]);
  return <div id="offer" className="py-16 bg-gradient-to-br from-blue-100 via-white to-red-100 relative" data-id="element-256">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-257">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-258"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-259">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-260">
          <span className="text-blue-700 mr-2" data-id="element-261">★</span>
          Special American Values Offer
          <span className="text-red-700 ml-2" data-id="element-262">★</span>
        </h2>
        <div className="bg-white p-0 rounded-xl shadow-xl border border-gray-200 mb-12 relative overflow-hidden" data-id="element-263">
          {/* Patriotic corner ribbon */}
          <div className="absolute top-0 right-0 w-32 h-32 overflow-hidden z-10" data-id="element-264">
            <div className="absolute top-0 right-0 transform translate-x-12 -translate-y-2 rotate-45 w-48 h-12 bg-red-700 text-white text-sm font-bold flex items-center justify-center shadow-lg border border-white z-20" data-id="element-265">
              AMERICAN MADE
            </div>
          </div>
          {/* Countdown banner */}

          <div className="p-8" data-id="element-266">
            <div className="hidden md:block mb-10" data-id="element-267">
              {/* Grid layout with 3 columns to display all options side by side */}
              <div className="hidden md:grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-268">
                {/* Digital Option */}
                <div className="flex flex-col h-full border border-gray-200 rounded-xl overflow-hidden bg-white shadow-lg transition-all duration-300 hover:shadow-xl hover:border-blue-300" data-id="element-269">
                  <div className="bg-blue-700 text-white p-4" data-id="element-270">
                    <h3 className="text-xl font-bold mb-1 text-center" data-id="element-271">
                      Digital Copy
                    </h3>
                    <p className="text-sm text-blue-100 text-center" data-id="element-272">
                      Instant Access
                    </p>
                  </div>
                  <div className="p-8 flex-grow flex flex-col" data-id="element-273">
                    <div className="flex items-center justify-center mb-6" data-id="element-274">
                      <p className="text-lg line-through text-gray-500 mr-2" data-id="element-275">
                        $47.97
                      </p>
                      <p className="text-3xl font-bold text-red-700" data-id="element-276">$19.97</p>
                    </div>
                    <div className="bg-green-50 rounded-lg p-4 mb-5 border-l-4 border-green-400" data-id="element-277">
                      <p className="text-green-800 font-medium text-sm" data-id="element-278">
                        <span className="font-bold" data-id="element-279">✓</span> Instant Download
                      </p>
                    </div>
                    <div className="bg-yellow-50 rounded-lg p-4 mb-8 border-l-4 border-yellow-400" data-id="element-280">
                      <p className="font-medium text-gray-800 text-sm" data-id="element-281">
                        <span className="text-yellow-600 font-bold" data-id="element-282">✓</span>{' '}
                        Includes 1 FREE Bonus!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45160891842746:1" className="mt-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg text-center transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1" data-id="element-283">
                      Get Digital Copy Now
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-4 mb-2" data-id="element-284">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55gCRTZKoFGxL5gocEXRzJ/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded opacity-80" loading="lazy" width="300" height="40" data-id="element-285" />
                    </div>
                    <div className="mt-4 flex items-center justify-center space-x-3 text-xs text-gray-500" data-id="element-286">
                      <div className="flex items-center" data-id="element-287">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-288">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-289"></path>
                        </svg>
                        <span data-id="element-290">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-291">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-292">
                          <circle cx="12" cy="12" r="10" data-id="element-293"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-294"></path>
                        </svg>
                        <span data-id="element-295">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-296">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-297">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-298"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-299"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-300"></path>
                        </svg>
                        <span data-id="element-301">Trusted</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Premium Hardcover Option - NOW IN THE MIDDLE */}
                <div className="flex flex-col h-full border-2 border-yellow-600 rounded-xl overflow-hidden bg-white shadow-xl transition-all duration-300 hover:shadow-2xl relative" data-id="element-302">
                  {/* PREMIUM Badge */}
                  <div className="absolute -top-7 -right-7 z-50" data-id="element-303">
                    <div className="bg-yellow-600 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg border-2 border-white" data-id="element-304">
                      PREMIUM
                    </div>
                  </div>
                  {/* Countdown Timer */}
                  <div className="bg-red-600 text-white p-2 -mx-0 -mt-0 rounded-t-none" data-id="element-305">
                    <div className="text-center" data-id="element-306">
                      <p className="text-xs font-bold uppercase mb-1" data-id="element-307">
                        Limited Time Offer Expires In:
                      </p>
                      <CountdownTimer data-id="element-308" />
                      <p className="text-xs mt-1 animate-pulse" data-id="element-309">
                        Only 7 Premium Editions Left at This Price!
                      </p>
                    </div>
                  </div>
                  <div className="bg-yellow-600 text-white p-4" data-id="element-310">
                    <h3 className="text-xl font-bold mb-1 text-center" data-id="element-311">
                      Premium Hardcover
                    </h3>
                    <p className="text-sm text-yellow-100 text-center" data-id="element-312">
                      Collector's Edition
                    </p>
                  </div>
                  <div className="p-8 flex-grow flex flex-col" data-id="element-313">
                    <div className="mb-5 flex justify-center md:block" data-id="element-314">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qgkkGRAZ38gXZGwtmSAeKn/Generated_Image_September_18%2C_2025_-_10_53AM.png" alt="Premium Hardcover Edition" className="w-32 h-auto rounded-md shadow-sm transition-transform duration-300 hover:scale-105 mx-auto" loading="lazy" width="200" height="300" data-id="element-315" />
                    </div>
                    <div className="flex items-center justify-between mb-1" data-id="element-316">
                      <p className="text-lg line-through text-gray-500" data-id="element-317">
                        $127.97
                      </p>
                      <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-bold" data-id="element-318">
                        SAVE $53.00
                      </div>
                    </div>
                    <p className="text-3xl font-bold text-red-700 mb-2" data-id="element-319">
                      $94.97
                    </p>
                    <div className="bg-green-100 rounded-lg p-3 mb-4 border-l-4 border-green-500 text-center" data-id="element-320">
                      <p className="text-green-800 font-bold text-sm" data-id="element-321">
                        <span className="font-bold" data-id="element-322">✓</span> FREE SHIPPING
                      </p>
                    </div>
                    <div className="bg-red-50 border border-red-200 rounded-md p-2 mb-4 text-center" data-id="element-323">
                      <p className="text-red-700 font-medium text-sm" data-id="element-324">
                        <span className="font-bold" data-id="element-325">⚠️</span> Special pricing
                        ends with countdown!
                      </p>
                    </div>
                    <div className="bg-yellow-50 rounded-lg p-4 mb-8 border-l-4 border-yellow-400" data-id="element-326">
                      <p className="font-medium text-gray-800 text-sm" data-id="element-327">
                        <span className="text-yellow-600 font-bold" data-id="element-328">✓</span>{' '}
                        Includes 3 FREE Bonuses!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45162754343098:1" className="mt-4 inline-block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg text-center transition-all duration-300 shadow-md" data-id="element-329">
                      Order Premium Edition
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-4 mb-2" data-id="element-330">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55gCRTZKoFGxL5gocEXRzJ/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded opacity-80" loading="lazy" width="300" height="40" data-id="element-331" />
                    </div>
                    <div className="mt-4 flex items-center justify-center space-x-3 text-xs text-gray-500" data-id="element-332">
                      <div className="flex items-center" data-id="element-333">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-334">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-335"></path>
                        </svg>
                        <span data-id="element-336">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-337">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-338">
                          <circle cx="12" cy="12" r="10" data-id="element-339"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-340"></path>
                        </svg>
                        <span data-id="element-341">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-342">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-343">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-344"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-345"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-346"></path>
                        </svg>
                        <span data-id="element-347">Trusted</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Physical Option - NOW LAST */}
                <div className="flex flex-col h-full border border-gray-200 rounded-xl overflow-hidden bg-white shadow-lg transition-all duration-300 hover:shadow-xl hover:border-red-300 relative" data-id="element-348">
                  {/* BEST DEAL Badge */}
                  <div className="absolute -top-7 -right-7 z-50" data-id="element-349">
                    <div className="bg-blue-700 text-white text-xs font-bold px-4 py-1 rounded-full shadow-lg border-2 border-white" data-id="element-350">
                      BEST DEAL
                    </div>
                  </div>
                  <div className="bg-red-700 text-white p-4" data-id="element-351">
                    <h3 className="text-xl font-bold mb-1 text-center" data-id="element-352">
                      Physical Copy
                    </h3>
                    <p className="text-sm text-red-100 text-center" data-id="element-353">
                      Most Popular
                    </p>
                  </div>
                  <div className="p-8 flex-grow flex flex-col" data-id="element-354">
                    <div className="flex items-center justify-center mb-6" data-id="element-355">
                      <p className="text-lg line-through text-gray-500 mr-2" data-id="element-356">
                        $67.97
                      </p>
                      <p className="text-3xl font-bold text-red-700" data-id="element-357">$49.97</p>
                    </div>
                    <div className="bg-amber-50 rounded-lg p-4 mb-5 border-l-4 border-amber-400" data-id="element-358">
                      <p className="text-amber-800 font-medium text-sm" data-id="element-359">
                        <span className="font-bold" data-id="element-360">✓</span> Shipping: 14 days
                        (high demand)
                      </p>
                    </div>
                    <div className="bg-yellow-50 rounded-lg p-4 mb-8 border-l-4 border-yellow-400" data-id="element-361">
                      <p className="font-medium text-gray-800 text-sm" data-id="element-362">
                        <span className="text-yellow-600 font-bold" data-id="element-363">✓</span>{' '}
                        Includes 2 FREE Bonuses!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45185632403642:1" className="mt-auto bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-lg text-center transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1" data-id="element-364">
                      Order Physical Copy
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-4 mb-2" data-id="element-365">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2c1KNAj9B1XNm2Nn36Xap1/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded opacity-80" loading="lazy" width="300" height="40" data-id="element-366" />
                    </div>
                    <div className="mt-4 flex items-center justify-center space-x-3 text-xs text-gray-500" data-id="element-367">
                      <div className="flex items-center" data-id="element-368">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-369">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-370"></path>
                        </svg>
                        <span data-id="element-371">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-372">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-373">
                          <circle cx="12" cy="12" r="10" data-id="element-374"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-375"></path>
                        </svg>
                        <span data-id="element-376">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-377">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600 mr-1" data-id="element-378">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-379"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-380"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-381"></path>
                        </svg>
                        <span data-id="element-382">Trusted</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Mobile layout preserved but hidden on desktop */}
            <div className="flex flex-col md:hidden items-center gap-8 mb-8" data-id="element-383">
              <div className="md:w-1/3 relative" data-id="element-384">
                <div className="absolute inset-0 rounded-md bg-gradient-to-tr from-red-700/20 via-white/20 to-blue-700/20" data-id="element-385"></div>
                {/* Book Cover with Badge */}
                <div className="relative" data-id="element-386">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inq4dLe15a2qVGibMXnZAc/Charlie_kirk_book_cover.png" alt="Remembering Charlie Kirk Book Cover" className="w-full max-w-xs mx-auto shadow-xl rounded-md relative z-10" loading="lazy" width="300" height="450" data-id="element-387" />
                  {/* "Now Available Online" Badge - Smaller size */}
                  <div className="absolute -top-3 -right-3 w-14 h-14 z-20" data-id="element-388">
                    <div className="relative w-full h-full" data-id="element-389"></div>
                  </div>
                </div>
              </div>
              <div className="md:w-2/3" data-id="element-390">
                <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-391">
                  {/* Digital Option */}
                  <div className="flex-1 border-2 border-blue-700 rounded-lg p-4 bg-blue-50 shadow-md" data-id="element-392">
                    <h3 className="text-xl font-bold text-blue-800 mb-2" data-id="element-393">
                      Digital Copy
                    </h3>
                    <p className="text-xl line-through text-gray-500" data-id="element-394">$47.97</p>
                    <p className="text-3xl font-bold text-red-700" data-id="element-395">$19.97</p>
                    <p className="text-green-700 font-medium mt-2" data-id="element-396">
                      Instant Download
                    </p>
                    <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-397">
                      <p className="font-medium text-gray-800" data-id="element-398">
                        Includes 1 FREE Bonus!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45160891842746:1" className="mt-4 inline-block w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-399">
                      Get Digital Copy Now
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-2 mb-2" data-id="element-400">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55gCRTZKoFGxL5gocEXRzJ/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded" loading="lazy" width="300" height="40" data-id="element-401" />
                    </div>
                    <div className="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-600" data-id="element-402">
                      <div className="flex items-center" data-id="element-403">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-404">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-405"></path>
                        </svg>
                        <span className="ml-1" data-id="element-406">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-407">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-408">
                          <circle cx="12" cy="12" r="10" data-id="element-409"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-410"></path>
                        </svg>
                        <span className="ml-1" data-id="element-411">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-412">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-413">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-414"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-415"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-416"></path>
                        </svg>
                        <span className="ml-1" data-id="element-417">Trusted</span>
                      </div>
                    </div>
                  </div>
                  {/* Premium Hardcover Option - MOVED TO MIDDLE */}
                  <div className="flex-1 border-2 border-yellow-600 rounded-lg p-4 bg-amber-50 shadow-md relative" data-id="element-418">
                    {/* PREMIUM Badge */}
                    <div className="absolute -top-7 -right-7 z-20" data-id="element-419">
                      <div className="bg-yellow-600 text-white text-xs font-bold px-3 py-1 rounded-full transform shadow-lg border-2 border-white animate-pulse" data-id="element-420">
                        SPECIAL DEAL
                      </div>
                    </div>
                    {/* Countdown Timer */}
                    <div className="bg-red-600 text-white p-2 -mx-4 -mt-4 mb-3 rounded-t-lg" data-id="element-421">
                      <div className="text-center" data-id="element-422">
                        <p className="text-xs font-bold uppercase mb-1" data-id="element-423">
                          Limited Time Offer Expires In:
                        </p>
                        <CountdownTimer data-id="element-424" />
                        <p className="text-xs mt-1 animate-pulse" data-id="element-425">
                          Only 7 Premium Editions Left at This Price!
                        </p>
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-blue-800 mb-2" data-id="element-426">
                      Premium Hardcover
                    </h3>
                    <div className="my-2" data-id="element-427">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qgkkGRAZ38gXZGwtmSAeKn/Generated_Image_September_18%2C_2025_-_10_53AM.png" alt="Premium Hardcover Edition" className="w-full rounded-md shadow-sm" loading="lazy" width="200" height="300" data-id="element-428" />
                    </div>
                    <div className="flex items-center justify-between mb-1" data-id="element-429">
                      <p className="text-xl line-through text-gray-500" data-id="element-430">
                        $127.97
                      </p>
                      <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-bold" data-id="element-431">
                        SAVE $53.00
                      </div>
                    </div>
                    <p className="text-3xl font-bold text-red-700" data-id="element-432">$94.97</p>
                    <div className="bg-green-100 rounded-lg p-2 mt-2 text-center border-l-4 border-green-500" data-id="element-433">
                      <p className="text-green-800 font-bold text-sm" data-id="element-434">
                        <span className="font-bold" data-id="element-435">✓</span> FREE SHIPPING
                      </p>
                    </div>
                    <div className="bg-red-50 border border-red-200 rounded-md p-2 mt-2 text-center" data-id="element-436">
                      <p className="text-red-700 font-medium text-sm" data-id="element-437">
                        <span className="font-bold" data-id="element-438">⚠️</span> Special pricing
                        ends with countdown!
                      </p>
                    </div>
                    <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-439">
                      <p className="font-medium text-gray-800" data-id="element-440">
                        Includes 3 FREE Bonuses!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45162754343098:1" className="mt-4 inline-block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg text-center transition-all duration-300 shadow-md" data-id="element-441">
                      Order Premium Edition
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-2 mb-2" data-id="element-442">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55gCRTZKoFGxL5gocEXRzJ/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded" loading="lazy" width="300" height="40" data-id="element-443" />
                    </div>
                    <div className="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-600" data-id="element-444">
                      <div className="flex items-center" data-id="element-445">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-446">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-447"></path>
                        </svg>
                        <span className="ml-1" data-id="element-448">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-449">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-450">
                          <circle cx="12" cy="12" r="10" data-id="element-451"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-452"></path>
                        </svg>
                        <span className="ml-1" data-id="element-453">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-454">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-455">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-456"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-457"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-458"></path>
                        </svg>
                        <span className="ml-1" data-id="element-459">Trusted</span>
                      </div>
                    </div>
                  </div>
                  {/* Physical Option - MOVED TO LAST */}
                  <div className="flex-1 border-2 border-red-700 rounded-lg p-4 bg-red-50 shadow-md relative" data-id="element-460">
                    {/* BEST DEAL Badge */}
                    <div className="absolute -top-7 -right-7 z-20" data-id="element-461"></div>
                    <h3 className="text-xl font-bold text-red-800 mb-2" data-id="element-462">
                      Physical Copy
                    </h3>
                    <p className="text-xl line-through text-gray-500" data-id="element-463">$67.97</p>
                    <p className="text-3xl font-bold text-red-700" data-id="element-464">$49.97</p>
                    <p className="text-amber-700 font-medium mt-2" data-id="element-465">
                      Shipping: 14 days (high demand)
                    </p>
                    <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-466">
                      <p className="font-medium text-gray-800" data-id="element-467">
                        Includes 2 FREE Bonuses!
                      </p>
                    </div>
                    <a href="https://www.voicesoffreedomus.com/cart/45185632403642:1" className="mt-4 inline-block w-full bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-468">
                      Order Physical Copy
                    </a>
                    {/* Payment methods image */}
                    <div className="mt-2 mb-2" data-id="element-469">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2c1KNAj9B1XNm2Nn36Xap1/stb.png" alt="Payment methods: Shop Pay, Amazon Pay, Google Pay" className="w-full max-w-xs mx-auto rounded" loading="lazy" width="300" height="40" data-id="element-470" />
                    </div>
                    <div className="mt-3 flex items-center justify-center space-x-2 text-xs text-gray-600" data-id="element-471">
                      <div className="flex items-center" data-id="element-472">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-473">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-474"></path>
                        </svg>
                        <span className="ml-1" data-id="element-475">Secure</span>
                      </div>
                      <div className="flex items-center" data-id="element-476">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-477">
                          <circle cx="12" cy="12" r="10" data-id="element-478"></circle>
                          <path d="m9 12 2 2 4-4" data-id="element-479"></path>
                        </svg>
                        <span className="ml-1" data-id="element-480">Guaranteed</span>
                      </div>
                      <div className="flex items-center" data-id="element-481">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600" data-id="element-482">
                          <rect width="20" height="12" x="2" y="6" rx="2" data-id="element-483"></rect>
                          <circle cx="12" cy="12" r="2" data-id="element-484"></circle>
                          <path d="M6 12h.01M18 12h.01" data-id="element-485"></path>
                        </svg>
                        <span className="ml-1" data-id="element-486">Trusted</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-700 p-4 mb-6" data-id="element-487">
                  <p className="text-lg font-medium" data-id="element-488">
                    But there's a catch: only a limited number of copies are
                    being released at this price for freedom-loving Americans.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-10 text-center" data-id="element-489">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center justify-center" data-id="element-490">
                <span className="text-red-700 mr-2" data-id="element-491">★</span>
                Take action now
                <span className="text-blue-700 ml-2" data-id="element-492">★</span>
              </h3>
              <p className="text-lg text-gray-700 mb-8" data-id="element-493">
                👉 Click below to claim your copy before this patriotic launch
                discount expires.
              </p>
              <a href="#offer" className="inline-block bg-gradient-to-r from-red-700 to-red-600 hover:from-red-800 hover:to-red-700 text-white font-bold py-4 px-10 rounded-lg text-xl transition-colors duration-300 shadow-xl border-2 border-white relative overflow-hidden group" data-id="element-494">
                <span className="relative z-10 flex items-center justify-center" data-id="element-495">
                  Get My Copy Now – Limited Time Offer
                  <svg className="w-5 h-5 ml-2 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-496">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-497" />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};